import { render, staticRenderFns } from "./ViewLiveGame.vue?vue&type=template&id=148c9fde&scoped=true&"
import script from "./ViewLiveGame.vue?vue&type=script&lang=js&"
export * from "./ViewLiveGame.vue?vue&type=script&lang=js&"
import style0 from "./ViewLiveGame.vue?vue&type=style&index=0&id=148c9fde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148c9fde",
  null
  
)

export default component.exports